import React, { useEffect, useState } from "react";
import { getLabelDate, hourFormat } from "functions/functions";
import CardItemEventoCalendarioParalimpicos from "../cardItemEventoCalendarioParalimpicos/cardItemEventoCalendarioParalimpicos";
import "./cardEventoCalendarioParalimpicos.sass";

const CardEventoCalendarioParalimpicos = React.memo(({
  mostrarTodos,
  setMostrarTodos,
  id,
  titulo,
  items,
  fechaInicio,
  fechaFin,
  sportCode,
  arrayMostrar,
  setArrayMostrar,
  fechaAnterior,
  valorFiltroCompetencias
}) => {
  const [frontDay, setFrontDay] = useState('');

  useEffect(() => {
    let newFrontDay = getLabelDate(fechaInicio);
    setFrontDay(newFrontDay);
  }, [fechaInicio, fechaAnterior, valorFiltroCompetencias]);
  
  // funcionamiento para abrir / cerrar las tarjetas
  const handleClickAbrirTarjeta = (idTarjeta) => {
    if (arrayMostrar.includes(idTarjeta)) {
      setArrayMostrar(arrayMostrar.filter((id) => id !== idTarjeta));
      setMostrarTodos(false);
    } else {
      setArrayMostrar([...arrayMostrar, idTarjeta]);
    }
  };

  return (
    <div className="section-evento" id="section-evento-paralimpicos">
      <div className={frontDay.length === 0 && !arrayMostrar.includes(id) ? "stepper-evento" : arrayMostrar.includes(id) ? "stepper-evento marginB-10" : "stepper-evento margin0stepper"}>
        <div className="card-evento-dia-horario">

          {(frontDay.length > 0 && frontDay !== getLabelDate(fechaAnterior)) && (
            <div className="card-evento-dia">
              <p className="label-dia">{frontDay}</p>
            </div>
          )}
          <div className="card-evento-horario">
            <p>{hourFormat(fechaInicio)}</p>
            <p className="separador-horario">-</p>
            <p>{hourFormat(fechaFin)}</p>
          </div>
          <div className={arrayMostrar.includes(id) ? "card-circle active" : "card-circle inactive"}></div>
        </div>
      </div>
      <div className={!arrayMostrar.includes(id) ? "card-completa-evento" : "card-completa-evento marginB-10"}>
        <div className="card-evento" id="card-evento-paralimpicos" onClick={() => handleClickAbrirTarjeta(id)}>
          <div className="card-evento-icono">
            <i className={
              sportCode === "CER" 
              ? `AMX-CER1` 
              : sportCode === 'PWL' 
                ?  `AMX-WLF1`
                : `AMX-${sportCode}1`
              }></i>
          </div>
          <div className="card-evento-titulo">
            <div className="statustitle">
              <div className="card-evento-titulo-p">{titulo}</div>
            </div>
            <div className="arrows-evento">
              <p>{items ? items.length : 0}</p>
              <div className={mostrarTodos || (arrayMostrar.length !== 0 && arrayMostrar.includes(id)) ? "arrow-top" : "arrow-bottom"}>
                <i className="play"></i>
              </div>
            </div>
          </div>
        </div>
        {((arrayMostrar.length !== 0 && arrayMostrar.includes(id) && !mostrarTodos) || (mostrarTodos && arrayMostrar.includes(id) && arrayMostrar.length !== 0)) &&
          items && items.map((item, index) => (
            <CardItemEventoCalendarioParalimpicos
              key={index}
              id={id}
              sportCode={sportCode}
              hourFormat={hourFormat}
              arrayMostrar={arrayMostrar}
              item={item}
              index={index}
            />
          ))}
      </div>
      <div className={"stepper-evento-bottom"}>
        <div className="final-line"></div>
      </div>
    </div>
  );
});

export default CardEventoCalendarioParalimpicos;
